import { Component, OnInit, Inject, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import * as moment from 'moment';

import { CommonService, AlertService, AdminService, ProfileService } from '../../../_services/';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-send-to-production-dialog',
  templateUrl: './send-to-production-dialog.component.html',
  styleUrls: ['./send-to-production-dialog.component.scss']
})

export class SendToProductionDialogComponent implements OnInit {

  sendToProductionForm:FormGroup;
  submitted:Boolean=false;
  subscription: any;
  constructor(
    public dialogRef: MatDialogRef<SendToProductionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private _common : CommonService,
    private _alert : AlertService,
    private _admin : AdminService,
    private _toastr : ToastrService,
    private _profile : ProfileService
  ) { }

  ngOnInit() {
    this.sendToProductionForm = this.fb.group({
      desired_production_week: [null, [Validators.required]],
      note: ["", []]
    }) 
    
  }
  
  hideSendToProductionDialog(){
    this.dialogRef.close();
  }

  get fval() {
    return this.sendToProductionForm.controls;
  }

  

  onFormSubmit():void {
    this.submitted = true;
    if (this.sendToProductionForm.invalid) {
      return;
    } 
    let form = this.sendToProductionForm.value;
    form.uid = localStorage.getItem('uid');

    this._common.showLoader(true);
    
    // Update Project
    let obj = {
      sent_to_production : 'Yes',
      desired_production_week : form.desired_production_week,
      desired_production_week_comment : form.note
    }
    
    this._admin.editProject(obj,this.data.project_id).then(res => {
      this._common.showLoader(false);
      // this._profile.changeSendToProduction({project_id:this.data.project_id,status:true});
      this.dialogRef.close();
    }).catch(error=>{
      this._toastr.error(`Something went wrong!`,"",{ timeOut: 4000 });
    })
  }


}